import * as Yup from 'yup';

// eslint-disable-next-line func-names
Yup.addMethod(Yup.number, 'customCast', function () {
  // eslint-disable-next-line react/no-this-in-sfc
  return this.transform((value, originalValue) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(originalValue)) {
      return null;
    }
    return value;
  });
});

export const apportionmentSchema = Yup.object({
  movements: Yup.array(Yup.object().shape({
    accountCenter: Yup.object().required('Campo obrigatório').nullable(),
    type: Yup.string().required('Campo obrigatório'),
    ponds: Yup.array().when('type', {
      is: (value) => value.includes('Sem rateio por viveiro'),
      then: Yup.array().notRequired(),
      otherwise: Yup.array().required('Campo obrigatório')
        .test('is-non-empty', 'Campo obrigatório', (array) => array && array.length > 0),
    }),
    value: Yup.number().required('Campo obrigatório').nullable().customCast(),
  })),
});
